@if (visibility) {
  @if (!hasLabel && visibility.level !== VisibilityLevel.Public) {
    <rt-icon
      [rtTooltip]="'app.visibility.visible_to_tooltip' | translate"
      [rtTooltipEnabled]="!editable"
      name="lock"
      margin-right-small-x
      colorToken="colorIconLowDefault"
    ></rt-icon>
  }

  @if (hasLabel) {
    <rt-button
      #visibilityDropdownTrigger="rtOverlayOrigin"
      [dropdownOpened]="dropdownOpened"
      [dropdownVisible]="editable"
      [disabled]="!editable"
      [variant]="buttonVariant"
      (click)="buttonClick()"
      class="visibility"
      margin-right-small-x
      rt-overlay-origin
      layout-flex-0-0
    >
      @if (visibility.level !== VisibilityLevel.Public) {
        <rt-icon
          [rtTooltip]="'app.visibility.visible_to_tooltip' | translate"
          [rtTooltipEnabled]="!editable"
          [name]="visibility.level === VisibilityLevel.Protected ? 'account-group' : 'lock'"
        ></rt-icon>
      }
      @if (visibility.level === VisibilityLevel.Public) {
        <rt-icon name="remove-red-eye"></rt-icon>
      }
      @if (visibility.level === VisibilityLevel.Protected) {
        <span class="action-text">{{ labels.selected.protected }}</span>
        @if (protectedUsersPosition === 'inside') {
          <div margin-left-small-xx>
            <ng-template [ngTemplateOutlet]="usersWrapperTmpl" />
          </div>
        }
      }
      @if (visibility.level === VisibilityLevel.Public) {
        <span class="action-text">{{ labels.selected.public }}</span>
      }
      @if (visibility.level === VisibilityLevel.Private) {
        <b class="action-text">{{ labels.selected.private }}</b>
      }
    </rt-button>
    <ng-template
      rt-connected-overlay
      hasBackdrop
      [positions]="dropdownPositions"
      [offsetX]="dropdownOffsetX"
      [offsetY]="dropdownOffsetY"
      [origin]="visibilityDropdownTrigger"
      [open]="dropdownOpened"
      (backdropClick)="toggleDropdown()"
    >
      <rt-visibility-selector-dropdown
        [infoContext]="infoContext"
        [hasOnlyMeLevel]="hasOnlyMeLevel"
        [hasSelectTeamMembers]="hasSelectTeamMembers"
        [visibility]="visibility"
        [labels]="labels.dropdown"
        (changeVisibilityLevel)="onChangeVisibilityLevel($event)"
        (toggleDropdown)="toggleDropdown()"
      ></rt-visibility-selector-dropdown>
    </ng-template>
  }

  @if (protectedUsersPosition === 'outside' && visibility.level === 'protected') {
    <div class="admins-wrapper">
      <rt-admins-avatars
        [admins]="$any(rolesWithAdmins)"
        [avatarSize]="protectedUsersPosition === 'outside' ? 'small' : 'small-x'"
        [isRole]="true"
        [stacked]="true"
        [limit]="avatarMaxLength"
        [isShort]="true"
        (moreClick)="setProtectedLevel()"
      ></rt-admins-avatars>
      <rt-admins-avatars
        [admins]="admins"
        [avatarSize]="protectedUsersPosition === 'outside' ? 'small' : 'small-x'"
        [limit]="avatarMaxLength"
        [isShort]="true"
        [stacked]="true"
        (moreClick)="setProtectedLevel()"
        [attr.margin-left-small-x]="protectedUsersPosition === 'outside' || null"
      ></rt-admins-avatars>
      @if (editable && allowAdminsChange && protectedUsersPosition === 'outside') {
        <rt-icon-button
          [disabled]="!hasSelectTeamMembers"
          (click)="setProtectedLevel()"
          variant="plain"
          class="action"
          iconName="add"
          size="small"
          margin-left-small-x
        >
        </rt-icon-button>
      }
    </div>
  }
}

<ng-template #usersWrapperTmpl>
  <div class="admins-wrapper">
    <rt-admins-avatars
      [admins]="$any(rolesWithAdmins)"
      [avatarSize]="protectedUsersPosition === 'outside' ? 'small' : 'small-x'"
      [isRole]="true"
      [stacked]="true"
      [limit]="avatarMaxLength"
      [isShort]="true"
      (moreClick)="setProtectedLevel()"
    ></rt-admins-avatars>
    <rt-admins-avatars
      [admins]="admins"
      [avatarSize]="protectedUsersPosition === 'outside' ? 'small' : 'small-x'"
      [limit]="avatarMaxLength"
      [isShort]="true"
      [stacked]="true"
      (moreClick)="setProtectedLevel()"
      [attr.margin-left-small-x]="protectedUsersPosition === 'outside' || null"
    ></rt-admins-avatars>
    @if (editable && allowAdminsChange && protectedUsersPosition === 'outside') {
      <rt-icon-button
        [disabled]="!hasSelectTeamMembers"
        (click)="setProtectedLevel()"
        variant="plain"
        class="action"
        iconName="add"
        size="small"
        margin-left-small-x
      >
      </rt-icon-button>
    }
  </div>
</ng-template>
